module.exports = __webpack_public_path__ + "img/retro_mo.8890b1b2.gif";